export default __webpack_public_path__ + "search-overview-final-product-1200-99518109f11403c364d2fd28152ef658.webp";